var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-oral';
                    var viewUrl = 'sprite.svg#view-icon-oral';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 40 40',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };